module.exports = __webpack_public_path__ + "img/delete-sentosa.9cfeacfe.svg";